import { getLocalStorage } from '@omnia/ui/src/lib'
import { getShowtimeById } from '@vista-digital/occ-domain'
import { useCallback, useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useInitialData } from '@/common/hooks/useInitialData'
import { matchesUrl } from '@/common/utils/matchUrls'

export const useNotificationBanners = () => {
    const { notificationBanners: allBanners = [] } = useInitialData()
    const location = useLocation()

    // we might need to separate `pageBanners` into two, will leave like this for now
    const closedBannersIds = getLocalStorage<string[]>('closedBanners')
    const filteredBanners = useMemo(() => allBanners.filter(b => !closedBannersIds?.includes(b.nodeId)), [allBanners])

    const { showtimeId = '' } = useParams<{ showtimeId: string }>()
    const siteId = useMemo(() => getShowtimeById(showtimeId)?.siteId ?? '', [showtimeId])

    const venueBanners = useMemo(
        () => filteredBanners?.filter(b => b.venue?.vistaCinema?.key === siteId) ?? [],
        [filteredBanners, siteId, location]
    )

    // all page banners including those that exists on `venueBanners`
    const getAllUrlMatchingBanners = useCallback(() => {
        const { pathname } = location
        return filteredBanners?.filter(b => b.urlFilter?.some(url => matchesUrl(url, pathname))) ?? []
    }, [location, filteredBanners])

    // `venueBanners`take more priority than `pageBanners`, so we're removing the duplicates on this `pageBanners`
    const pageBanners = useMemo(() => {
        const allUrlMatchingBanners = getAllUrlMatchingBanners()
        if (!siteId) return allUrlMatchingBanners

        return allUrlMatchingBanners?.filter(b => !venueBanners.includes(b)) ?? []
    }, [venueBanners, siteId, location])

    return { venueBanners, pageBanners }
}
